module.exports = __webpack_public_path__ + "static/media/coins_gray.edbdbcb9.svg";